import thread from "./thread";
import user from "./user";
import lead from "./lead";
import venue from "./venue";
import space from "./space";
import threadPreview from "./threadPreview";
const methods = {
  thread,
  thread_preview: threadPreview,
  user,
  lead,
  venue,
  space,
  organiser: user,
  host: user,
};
export default methods;
